export const T = {
  bg: '#F5F1E8',
  bgDeep: '#EBE5D6',
  card: '#FFFFFF',
  ink: '#1B1F1A',
  ink2: '#5C6258',
  ink3: '#9A9587',
  line: 'rgba(27,31,26,0.08)',
  lineStrong: 'rgba(27,31,26,0.14)',
  forest: '#2D5016',
  forestDeep: '#1F3810',
  forestSoft: '#E8EFE0',
  honey: '#D9962E',
  honeySoft: '#FBF1DC',
  rust: '#A8462B',
  font: '"SF Pro Text", -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif',
  fontDisplay: '"SF Pro Display", -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif',
  fontSerif: '"Source Serif 4", "Iowan Old Style", "Georgia", serif',
  fontMono: '"SF Mono", ui-monospace, Menlo, monospace',
  r: { sm: 10, md: 14, lg: 20, xl: 28, pill: 9999 },
  shadowCard: '0 1px 2px rgba(27,31,26,0.04), 0 4px 16px rgba(27,31,26,0.05)',
  shadowFloat: '0 6px 20px rgba(27,31,26,0.12), 0 2px 6px rgba(27,31,26,0.08)',
};

export const US_STATES = [
  ['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],
  ['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['FL','Florida'],['GA','Georgia'],
  ['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],
  ['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],
  ['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],['MO','Missouri'],
  ['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],
  ['NM','New Mexico'],['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],
  ['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],
  ['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],
  ['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming'],
];

export function familyColor(familyName = '') {
  const map = {
    'Swallowtail': '#C8A84B',
    'Brush': '#C97F3F',
    'White': '#B8B090',
    'Sulphur': '#C8B830',
    'Skipper': '#7A6040',
    'Gossamer': '#7A8FB8',
    'Metalmark': '#8B7355',
  };
  for (const [key, color] of Object.entries(map)) {
    if (familyName.includes(key)) return color;
  }
  const palette = ['#6B8F5E','#8B7355','#7A8FB8','#C97F3F','#9A7A4A','#6B7A6B'];
  let hash = 0;
  for (let i = 0; i < familyName.length; i++) hash = familyName.charCodeAt(i) + hash * 31;
  return palette[Math.abs(hash) % palette.length];
}
